import React, {useState, useEffect, useRef} from "react";
import {Container, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import Header from "../header";
import StickyBox from "react-sticky-box";
import ListSearchDuty from "./listSearchDuty";
import {Link, useLocation} from "react-router-dom";
import AuthService from "../util/AuthService";
import ApiService from "../util/ApiService";
import Select from "react-select";
import {DatePicker, Button} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import HospitalSearch from "../../../admin/components/hospital/HospitalSearch";
import Swal from "sweetalert2";
import {CCollapse, CButton} from '@coreui/react';
import "react-loading-skeleton/dist/skeleton.css";
import './assets/css/searchDuty.css';
import {HelmetProvider} from "react-helmet-async";
import HospitalModal from "../../../admin/components/hospital/HospitalModal";
import Footer from "../../../Layouts/Footer";

import Switch from "react-switch";
import StatesSelect from "../util/StatesSelect";

const {RangePicker} = DatePicker;

const SearchDuty = (props) => {
    document.title = "Buscar Plantão | Plantão Rápido";
    const location = useLocation();
    const isPublicRoute = location.pathname === '/duty-list';
    const [priceValue, setPriceValue] = useState(0);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [logo, setLogo] = useState(null);
    const [companyName, setCompanyName] = useState("Plantão Rápido");
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState([]);
    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [specialtiesLoading, setSpecialtiesLoading] = useState(false);
    const [specialties, setSpecialties] = useState([]);
    const [selectedUf, setSelectedUf] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [radius, setRadius] = useState(10);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [filters, setFilters] = useState({
        dateRange: "",
        specialties: [],
        hospital: "",
    });
    const [noResults, setNoResults] = useState(false);
    const hospitalSearchRef = useRef();
    const [sortOrder, setSortOrder] = useState('date_asc');

    const [collapseState, setCollapseState] = useState({
        collapseOne: true,
        collapseTwo: false,
        collapseThree: false,
        collapseFour: false,
        collapseFive: false,
        collapseSix: false,
        collapseSeven: false
    });

    useEffect(() => {

        if (AuthService.isAuthenticated()) {
            setIsAuthenticated(true);
        }

        // Carregar dados do custom domain
        const domain = window.location.hostname;
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            if (cachedImages.logo) {
                setLogo(cachedImages.logo);
            }
            if (cachedImages.title) {
                setCompanyName(cachedImages.title);
            }
        } catch (error) {
            console.error('Erro ao carregar dados customizados:', error);
        }

        loadSpecialties();

        // Tenta obter a localização do usuário
        // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition((position) => {
        //         const location = {
        //             latitude: position.coords.latitude,
        //             longitude: position.coords.longitude,
        //         };
        //         setCurrentLocation(location);
        //     }, (error) => {
        //         console.error("Erro ao obter localização:", error);
        //         setCurrentLocation(null);
        //     });
        // }

        // Cleanup ao desmontar o componente
        return () => document.body.classList.remove("map-page");
    }, []);


    useEffect(() => {
        if (currentLocation) {
            fetchDuties();
        }
    }, [currentLocation]);



    const loadSpecialties = () => {

        ApiService.send("get", `${process.env.REACT_APP_URL_API}specialties/list`, {}, false)
            .then((res) => {

                const {data} = ApiService.handleApiResponse(res);

                const specialtiesData = data.map((specialty) => ({
                    id: specialty.id,
                    name: specialty.name,
                }));
                localStorage.setItem("specialties", JSON.stringify(specialtiesData));
                setSpecialties(specialtiesData);
                setSpecialtiesLoading(false);
            })
            .catch((error) => {
                setSpecialtiesLoading(false);
            });

    };

    const fetchDuties = async (page = false) => {
        setLoading(true);
        setNoResults(false);


        const [startDate, endDate] = filters.dateRange;

        const params = {
            latitude: currentLocation ? currentLocation.latitude : undefined,
            longitude: currentLocation ? currentLocation.longitude : undefined,
            distance: radius,
            page: page,
            pagination: pagination.pageSize,
            uf: selectedUf ? selectedUf.value : undefined,
            id_city: selectedCity ? selectedCity.value : undefined,
            specialties: filters.specialties.length > 0 ? filters.specialties.join(',') : undefined,
            price: priceValue,
            datestart: startDate ? startDate.format('YYYY-MM-DD') : null,
            dateend: endDate ? endDate.format('YYYY-MM-DD') : null,
            hospital: filters.hospital,
            sort: sortOrder,
            freeForMe: true,
        };

        try {
            const endpoint = isAuthenticated ? 'duty/duty-record' : 'duty/duty-record-public';
            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + endpoint, params, isAuthenticated);


            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setDuties(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

            if (data.length === 0) {
                setNoResults(true);
            } else {
                setNoResults(false);
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setNoResults(true);
        } finally {
            setLoading(false);
        }
    };


    const handleSortChange = (sortValue) => {
        setSortOrder(sortValue);
    };

    const handleUfChange = (selectedOption) => {
        setSelectedUf(selectedOption);
        setSelectedCity(null);

        if (selectedOption) {
            ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: selectedOption.value}, false)
                .then((res) => {
                    const data = res.data;
                    if (!data.errors) {
                        setCities(
                            data.map((city) => ({
                                value: city.id,
                                label: city.name,
                                latitude: city.latitude,
                                longitude: city.longitude,
                            }))
                        );
                    }
                })
                .catch((error) => {

                });
        } else {
            setCities([]);
        }
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
    };

    const handleRadiusChange = (event) => {
        setRadius(event.target.value);
    };

    const handleSliderChange = (event) => {
        setPriceValue(parseInt(event.target.value));
    };

    const handleFilterChange = (changedFilters) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...changedFilters,
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setPagination({...pagination, current: 1});
        fetchDuties();
    };

    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            specialties: [],
            hospital: "",
        });
        setSelectedUf(null);
        setSelectedCity(null);
        setRadius(10);
        setPriceValue(0);
        setPagination({...pagination, current: 1});
        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }
    };

    const onHospitalSelect = (hospital) => {
        if (hospital) {
            handleFilterChange({hospital: hospital.value});
        } else {
            handleFilterChange({hospital: null});
        }
    };

    const handlePageChange = (page) => {

        fetchDuties(page);

    };

    const handleNewHospital = () => {
        // Lógica para adicionar um novo hospital
    };

    const toggleCollapse = (id) => {
        setCollapseState((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const userData = AuthService.getUserData();

    const renderPublicHeader = () => (
        <header id="page-topbar" className="public-header" style={{left: 0}}>
            <div className="container-fluid" style={{paddingLeft: 0}}>
                <div className="navbar-header" style={{paddingLeft: 0}}>
                    <div className="d-flex align-items-center" style={{marginLeft: '15px'}}>
                        <Link to={isAuthenticated ? "/admin" : "/duty-list"}>
                            {logo && <img src={logo} alt="" height="40" />}
                        </Link>
                    </div>

                    <div className="d-flex align-items-center">
                        {isAuthenticated ? (
                            <Dropdown isOpen={userDropdownOpen} toggle={() => setUserDropdownOpen(!userDropdownOpen)} className="ms-sm-3 header-item topbar-user">
                                <DropdownToggle tag="button" type="button" className="btn">
                                    <span className="d-flex align-items-center">
                                        <img
                                            className="rounded-circle header-profile-user"
                                            src={userData?.profile_image || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(userData?.name || 'User')}
                                            alt="Avatar"
                                            style={{width: '32px', height: '32px', objectFit: 'cover'}}
                                        />
                                        <span className="text-start ms-xl-2">
                                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                                {userData?.name?.split(' ')[0] || 'Usuário'}
                                            </span>
                                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                                {userData?.email || ''}
                                            </span>
                                        </span>
                                        <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <h6 className="dropdown-header">Bem vindo, {userData?.name?.split(' ')[0]}!</h6>
                                    <DropdownItem tag={Link} to="/admin">
                                        <i className="mdi mdi-view-dashboard text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Dashboard</span>
                                    </DropdownItem>
                                    <DropdownItem tag={Link} to="/admin/profile">
                                        <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Meu Perfil</span>
                                    </DropdownItem>
                                    <DropdownItem tag={Link} to="/admin/duty-my">
                                        <i className="mdi mdi-calendar-check text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Meus Plantões</span>
                                    </DropdownItem>
                                    <div className="dropdown-divider"></div>
                                    <DropdownItem tag={Link} to="/logout" className="text-danger">
                                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Sair</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        ) : (
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/login" className="btn btn-ghost-primary btn-sm">
                                    <i className="ri-login-box-line align-middle me-1"></i> Login
                                </Link>
                                <Link to="/register" className="btn btn-primary btn-sm">
                                    <i className="ri-user-add-line align-middle me-1"></i> Cadastrar
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );

    return (
        <React.Fragment>
            {isPublicRoute && renderPublicHeader()}
            <div className="page-content" style={isPublicRoute ? {marginLeft: 0, paddingTop: '70px'} : {}}>
                <Container fluid>
                    {!isPublicRoute && <BreadCrumb title="Buscar" pageTitle="Plantão"/>}
                    <Row>

                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-9 col-xxl-9">
                                {noResults ? (
                                    <div className="alert alert-primary" role="alert">
                                        Nenhum plantão encontrado.
                                    </div>
                                ) : (
                                    <ListSearchDuty
                                        duties={duties}
                                        loading={loading}
                                        pagination={pagination}
                                        onPageChange={handlePageChange}
                                        onSortChange={handleSortChange}
                                    />
                                )}
                            </div>
                            <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-3 col-xxl-3 theiaStickySidebar">
                                <StickyBox offsetTop={5} offsetBottom={20}>
                                    <div>
                                        <form onSubmit={onSubmit}>
                                            <div className="filter-contents">
                                                <div className="filter-header">
                                                    <Link
                                                        to={isPublicRoute ? "/duty-map" : "/admin/duty-search-map"}
                                                        className="btn btn-outline-info mt-3 w-100"
                                                    >
                                                        <span className="m-1"><i className="fa fa-map"></i> Acessar Mapa</span>
                                                    </Link>
                                                </div>
                                                <div className="filter-contents">
                                                    <h6 className="filter-title align-center">Filtro</h6>
                                                    {/* Filtro de Estado */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseOne')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseOne ? 'rotated' : ''}`}></i> Estado
                                                        </h6>
                                                        <CCollapse visible={collapseState.collapseOne}>
                                                            <div className="filter-collapse">
                                                                <div className="mt-3 mb-3">
                                                                    <StatesSelect value={selectedUf} onChange={handleUfChange} />
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Filtro de Cidade */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseTwo')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseTwo ? 'rotated' : ''}`}
                                                            ></i> Cidade
                                                        </h6>
                                                        <CCollapse visible={collapseState.collapseTwo}>
                                                            <div className="filter-collapse">
                                                                <div className="mt-3 mb-3">
                                                                    <Select
                                                                        value={selectedCity}
                                                                        onChange={handleCityChange}
                                                                        options={cities}
                                                                        placeholder="Selecione a Cidade"
                                                                        isDisabled={!selectedUf}
                                                                        isSearchable
                                                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                                        styles={{
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            }), // Definindo z-index alto
                                                                            menu: base => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            }) // Ajuste de z-index no próprio menu
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Filtro de Valor Plantão */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseFour')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseFour ? 'rotated' : ''}`}></i> Valor
                                                            Plantão
                                                        </h6>
                                                        <CCollapse visible={collapseState.collapseFour}>
                                                            <div>
                                                                <div>
                                                                    <div className="slider-wrapper">
                                                                        <div id="price-range"/>
                                                                    </div>
                                                                    <div className="price-wrapper">
                                                                        <div className="mt-3 mb-3">
                                                                            <input
                                                                                style={{width: "100%"}}
                                                                                id="price-range"
                                                                                type="range"
                                                                                min={0}
                                                                                max={10000}
                                                                                value={priceValue}
                                                                                onChange={handleSliderChange}
                                                                            />
                                                                            <h6>
                                                                                Valor maior que
                                                                                <span>&nbsp;
                                                                                    R$ <span
                                                                                        id="pricerangemin">{priceValue},00</span>
                                                                                     </span>
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Filtro de Especialidades */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseFive')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseFive ? 'rotated' : ''}`}></i> Especialidades
                                                        </h6>
                                                        <CCollapse visible={collapseState.collapseFive}>
                                                            <div className="filter-collapse" style={{
                                                                maxHeight: "250px",
                                                                overflowY: "auto"
                                                            }}>
                                                                <div className="mt-3 mb-3">
                                                                    {specialtiesLoading ? (
                                                                        <p>Carregando especialidades...</p>
                                                                    ) : (
                                                                        <ul style={{
                                                                            listStyle: 'none',
                                                                            paddingLeft: 0
                                                                        }}>
                                                                            {specialties.map((specialty) => (
                                                                                <li key={specialty.id}>
                                                                                    <label
                                                                                        className="custom_check d-inline-flex">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            name="speciality"
                                                                                            value={specialty.id}
                                                                                            checked={filters.specialties.includes(specialty.id)}
                                                                                            onChange={(e) => {
                                                                                                const isChecked = e.target.checked;
                                                                                                const selectedSpecialties = isChecked
                                                                                                    ? [...filters.specialties, specialty.id]
                                                                                                    : filters.specialties.filter((id) => id !== specialty.id);
                                                                                                handleFilterChange({specialties: selectedSpecialties});
                                                                                            }}
                                                                                        />
                                                                                        <span className="checkmark"/>
                                                                                        <span
                                                                                            className="specialties-text-filter ms-1">{specialty.name}</span>
                                                                                    </label>
                                                                                </li>

                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>
                                                    <div className="filter-grid mb-1">
                                                        <h6 onClick={() => toggleCollapse('collapseAccreditation')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseAccreditation ? 'rotated' : ''}`}></i> Credenciado
                                                        </h6>
                                                        <CCollapse
                                                            visible={collapseState.collapseAccreditation}>
                                                            <div className="filter-collapse" style={{
                                                                maxHeight: "300px",
                                                                overflowY: "auto"
                                                            }}>
                                                                <div className="mt-3 mb-3">
                                                                    <Switch
                                                                        checked={filters.is_credenciamento === 1}
                                                                        onChange={(checked) => setFilters({
                                                                            ...filters,
                                                                            is_credenciamento: checked ? 1 : 0
                                                                        })}
                                                                        onColor="#0d6efd"
                                                                        offColor="#ccc"
                                                                        uncheckedIcon={false}
                                                                        checkedIcon={false}
                                                                        title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"
                                                                        className="react-switch me-2"
                                                                    />
                                                                    <span>{filters.is_credenciamento === 1 ? "Sim" : "Não"}</span>
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Filtro de Data */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseSix')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseSix ? 'rotated' : ''}`}></i> Data
                                                        </h6>
                                                        <CCollapse visible={collapseState.collapseSix}>
                                                            <div className="filter-collapse">
                                                                <div className="mt-3 mb-3">
                                                                    <RangePicker
                                                                        style={{
                                                                            border: "none",
                                                                            boxShadow: "none"
                                                                        }}
                                                                        variant="outlined"
                                                                        locale={locale}
                                                                        format="DD/MM/YYYY"
                                                                        className="range-picker-custom"
                                                                        value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                                                        onChange={(dates) => handleFilterChange({dateRange: dates ? [dates[0], dates[1]] : []})}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Filtro de Hospital */}
                                                    <div className="filter-grid">
                                                        <h6 onClick={() => toggleCollapse('collapseSeven')}
                                                            style={{cursor: 'pointer'}}>
                                                            <i className={`fa fa-chevron-right ${collapseState.collapseSeven ? 'rotated' : ''}`}></i> Local
                                                        </h6>
                                                        <CCollapse
                                                            visible={collapseState.collapseSeven}>
                                                            <div className="filter-collapse"
                                                                 style={{
                                                                     height: "100px",
                                                                     overflowY: "auto"
                                                                 }}>
                                                                <div className="mt-3">
                                                                    <HospitalSearch
                                                                        all={true}
                                                                        statusTitle={false}
                                                                        buttonAdd={false}
                                                                        onHospitalSelect={onHospitalSelect}
                                                                        onNewHospital={handleNewHospital}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </CCollapse>
                                                    </div>

                                                    {/* Botões de Aplicar e Limpar Filtros */}
                                                    <div className="filter-btn ">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <button type="submit"
                                                                        className="btn btn-outline-primary btn-sm mt-3">
                                                                    <i className="fa-solid fa-magnifying-glass"></i> Buscar
                                                                </button>
                                                            </div>
                                                            <div className="col-6">
                                                                <button type="button"
                                                                    className="btn btn-outline-secondary btn-sm btn-lg mt-3"
                                                                    onClick={() => handleClearFilters()}>
                                                                    <i className="fa fa-eraser"></i> Limpar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </StickyBox>
                            </div>
                        </div>

                    </Row>
                </Container>
            </div>
            {isPublicRoute && <Footer />}
        </React.Fragment>
    );
};

export default SearchDuty;
